import isWithinTargetRange from './targetRange';

export const countBioMarkers = (bioMarkerData) => {
  const totalMarkers = bioMarkerData.length;

  const notMeasured = bioMarkerData.filter(marker => marker.value.raw === "Not Measured").length;

  const redFlags = bioMarkerData.filter(marker => {
    if (marker.value.raw === "Not Measured") return false;

    if (marker.marker === "Blood Pressure") {
      const { systolic, diastolic } = marker.value;
      const referenceTarget = marker.target?.reference;
      if (!systolic || !diastolic || !referenceTarget) return false;
      return !isWithinTargetRange({ systolic, diastolic }, referenceTarget);
    } else {
      const value = marker.value?.num;
      const referenceTarget = marker.target?.reference;
      if (value === undefined || !referenceTarget) return false;
      return !isWithinTargetRange(value, referenceTarget);
    }
  }).length;

  const greenCount = bioMarkerData.filter(marker => {
    if (marker.value.raw === "Not Measured") return false;

    if (marker.marker === "Blood Pressure") {
      const { systolic, diastolic } = marker.value;
      const userTarget = marker.target?.user;
      if (!systolic || !diastolic || !userTarget) return false;
      return isWithinTargetRange({ systolic, diastolic }, userTarget);
    } else {
      const value = marker.value?.num;
      const userTarget = marker.target?.user;
      if (value === undefined || !userTarget) return false;
      return isWithinTargetRange(value, userTarget);
    }
  }).length;

  const targetRange = bioMarkerData.filter(marker => {
    if (marker.value.raw === "Not Measured") return false;

    if (marker.marker === "Blood Pressure") {
      const { systolic, diastolic } = marker.value;
      const referenceTarget = marker.target?.reference;
      const userTarget = marker.target?.user;
      if (!systolic || !diastolic || !referenceTarget) return false;
      return isWithinTargetRange({ systolic, diastolic }, referenceTarget) &&
             !(userTarget && isWithinTargetRange({ systolic, diastolic }, userTarget));
    } else {
      const value = marker.value?.num;
      const referenceTarget = marker.target?.reference;
      const userTarget = marker.target?.user;
      if (value === undefined || !referenceTarget) return false;
      return isWithinTargetRange(value, referenceTarget) && 
             !(userTarget && isWithinTargetRange(value, userTarget));
    }
  }).length;

  return { totalMarkers, notMeasured, redFlags, greenCount, targetRange };
};
